(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-text.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-text.js');
'use strict';

const {
  IconMessage
} = svs.tb_ui_react.icon_message;

const MobileText = () => {
  const {
    mobileStatus,
    mobile
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings) || {};
  const mobileVerified = "".concat(mobileStatus) === '2';
  const mobileExists = Boolean(mobile);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    id: "currentMobileNumber"
  }, mobile || ''), !mobileVerified && React.createElement(IconMessage, {
    className: mobile ? 'padding-top-1' : ''
  }, mobileExists && React.createElement("span", null, "Ditt mobilnummer \xE4r obekr\xE4ftat"), !mobileExists && React.createElement("span", null, "Du har inget mobilnummer angivet")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileText = MobileText;

 })(window);